import { handleRequest } from "../../axios";
import { axiosInstance } from "./JsdhNotifikaceService";
import {
    ADMIN_KONTROLY_TYPY_URL,
    ADMIN_KONTROLY_TYP_BY_ID_URL,
    ADMIN_KONTROLY_URL,
    ADMIN_KONTROLY_BY_ID_URL,
    ADMIN_KONTROLY_UZIVATEL_URL,
    ADMIN_KONTROLY_HISTORIE_URL,
    ADMIN_KONTROLY_PREHLED_URL,
    ADMIN_KONTROLY_TYP_DASHBOARD_URL,
    ADMIN_KONTROLY_TYPY_SPLNITELNE_UCASTI_URL,
    ADMIN_KONTROLY_TYP_AKTIVNI_URL,
    ADMIN_KONTROLY_TYPY_NAHLED_URL,
} from "../url";
import type { TypKontroly, TypKontrolyRequest, NahledTypKontrolyRequest, NahledTypKontrolyResponse } from "../generated/models/TypKontroly";
import type {
    UzivatelKontrola,
    CreateKontrolaRequest,
    KontrolaStatusResponse,
    KontrolyOverviewResponse,
} from "../generated/models/Kontrola";

const getAllTypyKontrol = () => {
    return handleRequest<TypKontroly[]>(() =>
        axiosInstance.get(ADMIN_KONTROLY_TYPY_URL)
    );
};

const getTypyKontrolSplnitelneUcasti = () => {
    return handleRequest<TypKontroly[]>(() =>
        axiosInstance.get(ADMIN_KONTROLY_TYPY_SPLNITELNE_UCASTI_URL)
    );
};

const getTypKontrolyById = (id: number) => {
    return handleRequest<TypKontroly>(() =>
        axiosInstance.get(ADMIN_KONTROLY_TYP_BY_ID_URL(id))
    );
};

const createTypKontroly = (data: TypKontrolyRequest) => {
    return handleRequest<TypKontroly>(() =>
        axiosInstance.post(ADMIN_KONTROLY_TYPY_URL, data)
    );
};

const updateTypKontroly = (id: number, data: TypKontrolyRequest) => {
    return handleRequest<TypKontroly>(() =>
        axiosInstance.put(ADMIN_KONTROLY_TYP_BY_ID_URL(id), data)
    );
};

const deleteTypKontroly = (id: number) => {
    return handleRequest(() =>
        axiosInstance.delete(ADMIN_KONTROLY_TYP_BY_ID_URL(id))
    );
};

const createKontrola = (data: CreateKontrolaRequest) => {
    return handleRequest<UzivatelKontrola>(() =>
        axiosInstance.post(ADMIN_KONTROLY_URL, data)
    );
};

const updateKontrola = (id: number, data: CreateKontrolaRequest) => {
    return handleRequest<UzivatelKontrola>(() =>
        axiosInstance.put(ADMIN_KONTROLY_BY_ID_URL(id), data)
    );
};

const deleteKontrola = (id: number) => {
    return handleRequest(() =>
        axiosInstance.delete(ADMIN_KONTROLY_BY_ID_URL(id))
    );
};

const getKontrolyForUser = (uzivatelId: number) => {
    return handleRequest<KontrolaStatusResponse[]>(() =>
        axiosInstance.get(ADMIN_KONTROLY_UZIVATEL_URL(uzivatelId))
    );
};

const getKontrolyHistorie = (uzivatelId: number, typId: number) => {
    return handleRequest<UzivatelKontrola[]>(() =>
        axiosInstance.get(ADMIN_KONTROLY_HISTORIE_URL(uzivatelId, typId))
    );
};

const getKontrolyOverview = () => {
    return handleRequest<KontrolyOverviewResponse>(() =>
        axiosInstance.get(ADMIN_KONTROLY_PREHLED_URL)
    );
};

const toggleTypDashboard = (id: number, zobrazitDashboard: boolean) => {
    return handleRequest<{ success: boolean }>(() =>
        axiosInstance.patch(ADMIN_KONTROLY_TYP_DASHBOARD_URL(id), { zobrazitDashboard })
    );
};

const nastavTypAktivni = (id: number, aktivni: boolean) => {
    return handleRequest<{ success: boolean }>(() =>
        axiosInstance.patch(ADMIN_KONTROLY_TYP_AKTIVNI_URL(id), { aktivni })
    );
};

const nahledTypKontroly = (data: NahledTypKontrolyRequest) => {
    return handleRequest<NahledTypKontrolyResponse>(() =>
        axiosInstance.post(ADMIN_KONTROLY_TYPY_NAHLED_URL, data)
    );
};

const KontrolyServiceApi = {
    getAllTypyKontrol,
    getTypyKontrolSplnitelneUcasti,
    getTypKontrolyById,
    createTypKontroly,
    updateTypKontroly,
    deleteTypKontroly,
    createKontrola,
    updateKontrola,
    deleteKontrola,
    getKontrolyForUser,
    getKontrolyHistorie,
    getKontrolyOverview,
    toggleTypDashboard,
    nastavTypAktivni,
    nahledTypKontroly,
};

export default KontrolyServiceApi;
